<div class="pt-progress">
  <div class="pt-progress__heading">
    <h4>Policy progress</h4>
    <p>Track your application from submission to active coverage.</p>
  </div>

  <div class="pt-progress__steps">
    <div class="pt-step" *ngFor="let step of steps">
      <div class="pt-step__track">
        <div class="pt-step__line" [style.background]="step.lineLeft"></div>

        <ng-container [ngSwitch]="step.kind">
          <div *ngSwitchCase="'done'" class="pt-step__circle pt-step__circle--done">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12l5 5l10 -10"></path>
            </svg>
          </div>
          <div *ngSwitchCase="'activeEnd'" class="pt-step__circle pt-step__circle--active">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"></path>
              <path d="M9 12l2 2l4 -4"></path>
            </svg>
          </div>
          <div *ngSwitchCase="'current'" class="pt-step__circle pt-step__circle--current">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#50327d" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9"></circle>
              <path d="M12 7v5l3 3"></path>
            </svg>
          </div>
          <div *ngSwitchCase="'rejected'" class="pt-step__circle pt-step__circle--rejected">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M18 6l-12 12"></path>
              <path d="M6 6l12 12"></path>
            </svg>
          </div>
          <div *ngSwitchCase="'expiredEnd'" class="pt-step__circle pt-step__circle--expired">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 9v4"></path>
              <path d="M12 17h.01"></path>
            </svg>
          </div>
          <div *ngSwitchDefault class="pt-step__circle pt-step__circle--upcoming">
            <span class="pt-step__dot"></span>
          </div>
        </ng-container>

        <div class="pt-step__line" [style.background]="step.lineRight"></div>
      </div>

      <div class="pt-step__info">
        <span class="pt-step__label" [ngClass]="'pt-step__label--' + step.kind">{{ step.label }}</span>
        <span class="pt-step__date">
          <ng-container *ngIf="step.date; else noDate">{{ step.prefix }} {{ step.date | date : "MMM d, y" }}</ng-container>
          <ng-template #noDate>&mdash;</ng-template>
        </span>
      </div>
    </div>
  </div>
</div>
